import { Wrapper } from "nystem-components";

const providerLabels = {
  datalab: "Datalab",
  datalabForceOcr: "Datalab force OCR",
  openai: "OpenAI",
  openaiSchoolRegister: "OpenAI school register",
};

const isProgress = (value) => Number.isFinite(Number(value));

const progressText = (value) => {
  const number = Number(value);
  return number === -1 ? "-1" : `${Math.round(number)}%`;
};

const ProgressTag = ({ label, value, compact }) => (
  <Wrapper
    renderAs="span"
    title={value === -1 ? `${label} OCR error` : `${label} OCR progress`}
    className={[
      "inline-flex",
      "items-center",
      "rounded",
      "border",
      "px-2",
      "py-1",
      "text-sm",
      value === -1
        ? "border-red-300 bg-red-50 text-red-800"
        : "border-gray-300 bg-gray-100 text-gray-900",
    ]}
  >
    {!compact && <Wrapper renderAs="span" className="mr-2">{label}</Wrapper>}
    <Wrapper renderAs="span" className="font-semibold">
      {progressText(value)}
    </Wrapper>
  </Wrapper>
);

const TextOcrProgress = ({ model, value, view }) => {
  const progress = value || view.value?.ocrProgress || {};
  const providers = model.provider
    ? [model.provider]
    : ["openai", "openaiSchoolRegister", "datalab", "datalabForceOcr"];
  const active = providers
    .map((provider) => ({
      label: model.label || providerLabels[provider] || provider,
      provider,
      value: progress[provider],
    }))
    .filter(({ provider, value }) => !view.value?.[provider] && isProgress(value));

  if (!active.length) return null;

  return (
    <Wrapper className={["flex", "flex-wrap", "gap-2", model.className]}>
      {active.map(({ label, provider, value }) => (
        <ProgressTag
          key={provider}
          compact={model.compact}
          label={label}
          value={Number(value)}
        />
      ))}
    </Wrapper>
  );
};

export default TextOcrProgress;
